export default __webpack_public_path__ + "0b6a2108f90b4682e1399525058f1c95.png";